import { getChannel } from "./preflight"

const GetQueryString = function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return unescape(r[2])
    }
    return null
}

const ReplaceParamVal = function (paramName, replaceWith, link) {
    let url = link || window.location.href.toString()
    let newUrl = ""
    let pattern = paramName + "=([^&]*)"
    let replaceText = paramName + "=" + encodeURIComponent(replaceWith)
    if (url.match(pattern)) {
        newUrl = "/(" + paramName + "=)([^&]*)/gi"
        newUrl = url.replace(eval(newUrl), replaceText)
    } else {
        if (url.indexOf("?") > -1) {
            newUrl = url + "&" + replaceText
        } else {
            newUrl = url + "?" + replaceText
        }
    }
    return newUrl
}

function getQueryParams(url = window.location) {
    let queryString = ""

    // 判断是 history 模式还是 hash 模式
    if (url.search) {
        // history 模式，查询参数在 `?` 后面
        queryString = url.search.slice(1)
    } else if (url.hash.includes("?")) {
        // hash 模式，查询参数在 `#` 后的 `?` 后面
        queryString = url.hash.split("?")[1]
    }

    // 使用 URLSearchParams 来解析参数
    const params = new URLSearchParams(queryString)
    const queryParams = {}

    // 遍历所有参数并存入对象
    params.forEach((value, key) => {
        queryParams[key] = value
    })

    return queryParams
}

function appendMaterialReference(link, params = {}) {
    const channel = getChannel()
    if (!link || (!channel && !Object.keys(params).length)) return link

    const target = new URL(link, window.location.origin)
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            target.searchParams.delete(key)
        } else {
            const paramValue = String(value)
            if (!target.searchParams.getAll(key).includes(paramValue)) {
                target.searchParams.append(key, paramValue)
            }
        }
    })
    if (channel && !target.searchParams.getAll("m_ref").includes(channel)) {
        target.searchParams.append("m_ref", channel)
    }

    // URLSearchParams 会将空格序列化为 +，此处仅规范查询字符串的空格编码。
    target.search = target.search.replace(/\+/g, "%20")
    return target.toString()
}

export { appendMaterialReference, GetQueryString, ReplaceParamVal, getQueryParams }
